import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function Members() {
  const { isAuthenticated } = useAuth();
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const buyNow = async () => {
    if (!isAuthenticated) {
      window.location.href = '/login';
      return;
    }

    const token = localStorage.getItem('token');
    setLoading(true);
    setMessage('');
    try {
      const res = await fetch('/api/payment/create-checkout-session', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({ tier: 'members' })
      });
      const data = await res.json();
      if (res.ok && data.url) {
        window.location.href = data.url;
        return;
      }
      setMessage(data.message || 'Could not start Stripe checkout.');
    } catch {
      setMessage('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page">
      <div className="card" style={{ maxWidth: '900px', margin: '0 auto' }}>
        <h1 style={{ marginBottom: '0.5rem' }}>Members Tier</h1>
        <p style={{ color: 'var(--color-text-light)', marginBottom: '1rem' }}>
          Questions 1 to 50, with bonus access continuing through question 150.
        </p>

        <ul style={{ lineHeight: 1.9, paddingLeft: '1.2rem', listStyle: 'disc' }}>
          <li>Core pagination: questions 1 to 50</li>
          <li>Bonus pagination: questions 51 to 150</li>
          <li>AI-generated questions and examples</li>
          <li>Answer in text area by client</li>
          <li>Business Title button and title list (click title to open its question page)</li>
          <li>Buttons: Save Page, Grade Page, Rate Page, Average Page</li>
        </ul>

        <div style={{ marginTop: '1rem', marginBottom: '1rem', fontWeight: 700 }}>
          <span style={{ marginRight: '0.5rem', color: 'var(--color-muted)', textDecoration: 'line-through' }}>$49.00</span>
          <span style={{ color: 'var(--color-secondary-dark)' }}>$39.00</span>
          <span style={{ marginLeft: '0.5rem', fontWeight: 500 }}>20% off (Save $10.00)</span>
        </div>

        {message && <div className="alert alert-danger">{message}</div>}

        <div style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap' }}>
          <button className="btn btn-primary" onClick={buyNow} disabled={loading}>
            {loading ? 'Redirecting…' : 'Buy Now with Stripe'}
          </button>
          <Link to="/dashboard" className="btn btn-secondary">Open Members Page</Link>
        </div>
      </div>
    </div>
  );
}
